var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V11.9995M12 11.9995L16 15M12 11.9995C12 11.9998 11.9997 11.9993 12 11.9995ZM1.28533 14.5C1.09868 13.6969 1 12.86 1 12C1 11.14 1.09868 10.3031 1.28533 9.5M10 1.18138C10.6486 1.06225 11.317 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C11.317 23 10.6486 22.9378 10 22.8186M6.5 2.4716C4.99963 3.33952 3.72328 4.55165 2.77893 6M2.77893 18C3.72328 19.4484 4.99963 20.6605 6.5 21.5284",
    stroke: "blue",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.5280a78e601c2faa2051200c4966a93b.svg";
export { ForwardRef as ReactComponent };